import { api } from '@marketplace-web/core-api/core-api-client-util'

import {
  GetIsAutomatedSupportFeedbackEnabledArgs,
  IsAutomatedResponseFeedbackEnabledResp,
} from '../types/automated-response-feedback'

export const getIsAutomatedSupportFeedbackEnabled = (
  args: GetIsAutomatedSupportFeedbackEnabledArgs,
) =>
  api.get<IsAutomatedResponseFeedbackEnabledResp>(
    `/users/${args.userId}/msg_threads/${args.conversationId}/automated_support_feedback`,
    { params: { survey_version: args.surveyVersion } },
  )
